import React, { useEffect } from "react";
import styles from "./MobileModal.Modal.module.scss";
import ModalBottom from "../ModalBottom";
import closeButton from "../../../static/icons/close.svg";
import spinconnectLogo from "../../../static/icons/spin-v2.svg";
import Button from "../../Button";

export default ({ _, onClose }) => {
  return (
    <ModalBottom isOpen>
      <div className={styles.UploadSelectionModal}>
        <div className={styles.header}>
          <div className={styles.backButton} onClick={onClose}>
            <img src={closeButton} alt="" />
          </div>
          <img src={spinconnectLogo} />
        </div>
        <div className={styles.content}>
          <div className={styles.information}>
            {" "}
            <span>i</span>
          </div>
          <div className={styles.title}>This is a desktop experience</div>
          <div className={styles.subMessage}>
            In order to upload, mint and connect your smart-products, please
            make sure to download SPIN OS on your desktop computer.
          </div>
          <div className={styles.buttonContainer}>
            <Button
              type="button"
              size="large"
              onClick={onClose}
              className={styles.okButton}
            >
              <span>OK</span>
            </Button>
          </div>
        </div>
      </div>
    </ModalBottom>
  );
};
